import {FC, PropsWithChildren} from 'react';
import style from './style.module.scss';
import {TPropsWithClassName} from 'core/types';
import classNames from 'classnames';

export const BlockTitle: FC<TPropsWithClassName<PropsWithChildren>> = ({children, className}) => {
    return <div className={classNames(style.titleWrapper, className)}>{children}</div>;
};
